export default "__VITE_PUBLIC_ASSET__524eae13__"